import moment from "moment";
import { priceOptions } from "@/modules/Application"

export default {
  methods: {
    formatCpfCnpj(valor) {
      if (valor === null || valor === undefined || valor === "") {
        return "";
      }

      const value = String(valor);
      const cnpj = value
        .trim()
        .replace(/[./-]/g, "")
        .toUpperCase();

      if (cnpj.length === 14 || /[A-Z]/.test(cnpj)) {
        return cnpj
          .slice(0, 14)
          .replace(/^(.{2})(.{3})(.{3})(.{4})(.{2})$/, "$1.$2.$3/$4-$5");
      }

      const cpf = value.replace(/\D/g, "");

      if (cpf.length <= 11) {
        // eslint-disable-next-line
        return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, `\$1.\$2.\$3\-\$4`);
      }

      // eslint-disable-next-line
      return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "\$1.\$2.\$3\/\$4\-\$5");
    },
    valorUS(valor = 0) {
      let valorFormatado = valor;
      if (typeof valor === "string") {
        valorFormatado = valor.split(".").join("");
        return parseFloat(valorFormatado.replace(",", ".").replace("R$ ", ""));
      }
      return 0;
    },
    valorReal(valor = 0, aplyConfig) {
      return valor.toLocaleString("pt-br", {
        minimumFractionDigits: aplyConfig ? priceOptions.precision : 2,
      });
    },
    roundTo2Digits(value, decPlaces = 2) {
      return Math.round(value * Math.pow(10, decPlaces)) / Math.pow(10, decPlaces);
    },
    formatDate(value, fmt = "DD/MM/YYYY") {
      return value === null
        ? ""
        : moment(value, "YYYY-MM-DD HH:mm:ss").format(fmt);
    },
  },
};
